<section>
    <!-- directive tenant-theme controls the color theme of the entire app -->
    <div id="scroll" tenant-theme>
        <router-outlet></router-outlet>
    </div>
</section>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
